import React, { useState } from "react";
import SegmentedControl from "./components/SegmentedControl/SegmentedControl";

function App() {
  const options = [
    {
      id: 0,
      label: "하나",
      value: "하나",
    },
    {
      id: 1,
      label: "둘",
      value: "둘",
    },
    {
      id: 2,
      label: "셋",
      value: "셋",
    },
  ];
  const [selectedVal1, setSelectedVal1] = useState(options[0].value);
  const [selectedVal2, setSelectedVal2] = useState(options[2].value);
  const [selectedVal3, setSelectedVal3] = useState(options[0].value);

  return (
    <div className="App">
      <SegmentedControl
        callback={(val) => setSelectedVal1(val)}
        options={options.slice(0, 2)}
      ></SegmentedControl>
      <p>Size: large, Selected value: {selectedVal1}</p>
      <SegmentedControl
        callback={(val) => setSelectedVal2(val)}
        defaultOpt={2}
        options={options}
      ></SegmentedControl>
      <p>Size: large, Selected value: {selectedVal2}</p>
      <SegmentedControl
        callback={(val) => setSelectedVal3(val)}
        options={options}
        size="small"
      ></SegmentedControl>
      <p>Size: small, Selected value: {selectedVal3}</p>
    </div>
  );
}

export default App;
